// extracted by mini-css-extract-plugin
export default {"recos":"_2-z","productCardOverride":"a3-z","rowHasBadge":"b3-z"};